import Slide from '@mui/material/Slide';

export const TransitionRight = props => {
	return <Slide {...props} direction="right" />;
};
